import React, { useState } from "react";

const HVACMasterlist = () => {
  const [activeTab, setActiveTab] = useState("services");

  return (
    <div className="min-h-screen bg-black text-gray-200 px-4 py-6 md:px-10">
      {/* Header */}
      <header className="mb-2">
        <h1 className="text-xl lg:text-2xl font-bold text-white flex items-center gap-3">
          <i className="fa-solid fa-toolbox text-yellow-400"></i>
          HVAC Master List
        </h1>
        <p className="mt-2 text-xs lg:text-sm text-gray-400 leading-relaxed">
          Complete Services & Equipment List for HVAC, powered by Think5Whys TaaP.
        </p>
      </header>

      {/* Tabs */}
      <div className="flex gap-4 mb-2">
        <button
          className={`w-40 lg:w-64 text-sm lg:text-lg px-2 py-2 rounded-md font-semibold ${
            activeTab === "services"
              ? "bg-yellow-400 text-black"
              : "bg-gray-800 text-gray-300"
          }`}
          onClick={() => setActiveTab("services")}
        >
          🛠️ Services
        </button>
        <button
          className={`w-40 lg:w-64 text-sm lg:text-lg px-2 py-2 rounded-md font-semibold ${
            activeTab === "equipment"
              ? "bg-yellow-400 text-black"
              : "bg-gray-800 text-gray-300"
          }`}
          onClick={() => setActiveTab("equipment")}
        >
          🔧 Equipment
        </button>
      </div>

      {/* Services Tab */}
      {activeTab === "services" && (
        <div className="[&>ul]:text-white [&>li]:text-white space-y-6 text-sm md:text-base">
          {/* 1. CONSULTING, ADVISORY & PRE-PROJECT SERVICES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              1. CONSULTING, ADVISORY & PRE-PROJECT SERVICES
            </h2>
            <ul className="list-disc pl-6 [&>li]:text-white">
              <li>HVAC Feasibility Study</li>
              <li>Load Calculation (Heat Load / Cooling Load)</li>
              <li>HVAC System Selection Advisory</li>
              <li>Energy Modeling & Simulation</li>
              <li>HVAC Concept Design Review</li>
              <li>Retrofit Feasibility Assessment</li>
              <li>Green Building / Net-Zero Advisory</li>
              <li>IAQ (Indoor Air Quality) Assessment</li>
              <li>District Cooling Advisory</li>
              <li>HVAC Cost–Benefit & ROI Analysis</li>
            </ul>
          </section>

          {/* 2. DESIGN & ENGINEERING SERVICES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              2. DESIGN & ENGINEERING SERVICES
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>HVAC Detailed Design (Ducting & Piping)</li>
              <li>VRF System Design</li>
              <li>Chiller Plant Design</li>
              <li>Heat Pump System Design</li>
              <li>BMS & Controls Design</li>
              <li>Refrigerant Selection & Compliance Design</li>
              <li>CFD Analysis for Airflow</li>
              <li>Value Engineering (HVAC)</li>
              <li>Shop Drawings & As-Built Drawings</li>
            </ul>
          </section>

          {/* 3. PROCUREMENT & SUPPLY CHAIN SERVICES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              3. PROCUREMENT & SUPPLY CHAIN SERVICES
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Equipment Sourcing & Vendor Evaluation</li>
              <li>Technical Submittals & Approvals</li>
              <li>Localisation / PLI Advisory</li>
              <li>Logistics & Import Coordination</li>
              <li>Spare Parts Planning & Inventory Setup</li>
            </ul>
          </section>

          {/* 4. INSTALLATION & CONSTRUCTION SERVICES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              4. INSTALLATION & CONSTRUCTION SERVICES
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>HVAC System Installation</li>
              <li>VRF / VRV Installation</li>
              <li>Chiller Plant Installation</li>
              <li>AHU / FAHU Installation</li>
              <li>Duct Fabrication & Installation</li>
              <li>Chilled Water / Refrigerant Piping</li>
              <li>Electrical & Controls Installation</li>
              <li>Insulation & Cladding Works</li>
              <li>Equipment Rigging & Positioning</li>
            </ul>
          </section>

          {/* 5. TESTING, COMMISSIONING & HANDOVER */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              5. TESTING, COMMISSIONING & HANDOVER
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Pre-Commissioning Checks</li>
              <li>Functional Testing of HVAC Systems</li>
              <li>Testing, Adjusting & Balancing (TAB)</li>
              <li>Performance Validation</li>
              <li>Safety & Leak Testing (A2L Ready)</li>
              <li>BMS Integration Testing</li>
              <li>Final Commissioning</li>
              <li>System Handover & O&M Training</li>
            </ul>
          </section>

          {/* 6. OPERATIONS, MAINTENANCE & SERVICE */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              6. OPERATIONS, MAINTENANCE & SERVICE
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li><strong>Preventive & Corrective:</strong> Preventive Maintenance (PM), Predictive Maintenance (IoT-based), Breakdown Maintenance, Emergency HVAC Service, Seasonal Start-up & Shutdown</li>
              <li><strong>Asset Management:</strong> HVAC Asset Health Monitoring, AMC / CMC Contracts, Spare Parts Management, Lifecycle Cost Optimization</li>
            </ul>
          </section>

          {/* 7. RETROFIT, UPGRADE & MODERNIZATION */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              7. RETROFIT, UPGRADE & MODERNIZATION
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>HVAC Retrofit Services</li>
              <li>Energy Efficiency Upgrades</li>
              <li>Chiller Replacement / Optimization</li>
              <li>VRF Conversion</li>
              <li>Electrification & Heat Pump Retrofit</li>
              <li>Control System Modernization</li>
              <li>Refrigerant Transition (Low-GWP)</li>
            </ul>
          </section>

          {/* 8. ENERGY, IAQ & SUSTAINABILITY SERVICES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              8. ENERGY, IAQ & SUSTAINABILITY SERVICES
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Energy Audits (HVAC Focused)</li>
              <li>Energy Performance Contracting (EPC)</li>
              <li>Demand Response & Load Optimization</li>
              <li>IAQ Improvement Services</li>
              <li>Carbon Footprint Measurement</li>
              <li>ESG / Sustainability Reporting</li>
              <li>Net-Zero HVAC Roadmapping</li>
            </ul>
          </section>

          {/* 9. SMART HVAC, DIGITAL & IOT SERVICES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              9. SMART HVAC, DIGITAL & IOT SERVICES
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Smart HVAC System Integration</li>
              <li>BMS / SCADA Integration</li>
              <li>IoT Sensor Deployment</li>
              <li>Digital Twin Creation</li>
              <li>Remote Monitoring & Diagnostics</li>
              <li>AI-Driven Predictive Analytics</li>
              <li>HVAC Cybersecurity Assessment</li>
            </ul>
          </section>

          {/* 10. SAFETY, COMPLIANCE & REGULATORY SERVICES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              10. SAFETY, COMPLIANCE & REGULATORY SERVICES
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Refrigerant Safety Audits</li>
              <li>A2L Refrigerant Compliance</li>
              <li>Fire & Smoke Control Testing</li>
              <li>Occupational Health & Safety Audits</li>
              <li>Statutory Compliance (BIS, ASHRAE, ISO)</li>
              <li>Environmental & Emissions Compliance</li>
            </ul>
          </section>

          {/* 11. SPECIALIZED & SECTOR-SPECIFIC SERVICES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              11. SPECIALIZED & SECTOR-SPECIFIC SERVICES
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Clean Room HVAC Services</li>
              <li>Data Center Cooling Services</li>
              <li>Hospital & Healthcare HVAC</li>
              <li>Industrial Process Cooling</li>
              <li>Cold Storage & Refrigeration Services</li>
              <li>District Cooling O&M</li>
            </ul>
          </section>

          {/* 12. TRAINING, CERTIFICATION & WORKFORCE SERVICES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              12. TRAINING, CERTIFICATION & WORKFORCE SERVICES
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>HVAC Skill Training Programs</li>
              <li>VRF & Advanced System Training</li>
              <li>Refrigerant Safety Certification</li>
              <li>BMS & Controls Training</li>
              <li>On-Site Technician Upskilling</li>
              <li>Master Technician Development</li>
              <li>Think5Whys Diagnostic Training</li>
            </ul>
          </section>

          {/* 13. FINANCIAL, COMMERCIAL & BUSINESS SERVICES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              13. FINANCIAL, COMMERCIAL & BUSINESS SERVICES
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>HVAC-as-a-Service (HVACaaS)</li>
              <li>Leasing & Subscription Models</li>
              <li>Performance-Based Contracts</li>
              <li>Warranty & Extended Warranty Management</li>
              <li>Insurance & Risk Coverage Advisory</li>
            </ul>
          </section>

          {/* 14. CUSTOMER EXPERIENCE & SUPPORT SERVICES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              14. CUSTOMER EXPERIENCE & SUPPORT SERVICES
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Customer Helpdesk & Ticketing</li>
              <li>Service Level Agreement (SLA) Management</li>
              <li>Complaint Resolution & RCA</li>
              <li>Digital Service Reports</li>
              <li>Customer Feedback & NPS Tracking</li>
            </ul>
          </section>

          {/* 15. ECOSYSTEM, EVENTS & KNOWLEDGE SERVICES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              15. ECOSYSTEM, EVENTS & KNOWLEDGE SERVICES
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>HVAC Workshops & Bootcamps</li>
              <li>Industry Conferences & Summits</li>
              <li>OEM–MSME Collaboration Programs</li>
              <li>Research & Whitepaper Services</li>
              <li>Policy Advocacy & Industry Representation</li>
            </ul>
          </section>
        </div>
      )}

      {/* Equipment Tab */}
      {activeTab === "equipment" && (
        <div className="[&>ul]:text-white [&>li]:text-white space-y-6 text-sm md:text-base">
          {/* 1. COOLING & HEATING GENERATION EQUIPMENT */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              1. COOLING & HEATING GENERATION EQUIPMENT
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Air-Cooled Chiller</li>
              <li>Water-Cooled Chiller</li>
              <li>Centrifugal Chiller</li>
              <li>Screw Chiller</li>
              <li>Scroll Chiller</li>
              <li>Absorption Chiller</li>
              <li>Magnetic Bearing Chiller</li>
              <li>Modular Chiller</li>
              <li>Air-Source Heat Pump (ASHP)</li>
              <li>Ground-Source / Geothermal Heat Pump (GSHP)</li>
              <li>Water-Source Heat Pump</li>
              <li>Hybrid Heat Pump</li>
              <li>VRF Heat Pump Systems</li>
              <li>Gas-Fired Boiler</li>
              <li>Electric Boiler</li>
              <li>Oil-Fired Boiler</li>
              <li>Biomass Boiler</li>
              <li>Condensing Boiler</li>
              <li>Steam Boiler</li>
              <li>Hot Water Generator</li>
            </ul>
          </section>

          {/* 2. REFRIGERATION & COMPRESSION EQUIPMENT */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              2. REFRIGERATION & COMPRESSION EQUIPMENT
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Scroll Compressor</li>
              <li>Screw Compressor</li>
              <li>Centrifugal Compressor</li>
              <li>Reciprocating Compressor</li>
              <li>Inverter / Variable Speed Compressor</li>
              <li>Magnetic Bearing Compressor</li>
              <li>Condensing Unit</li>
              <li>Evaporator</li>
              <li>Condenser (Air / Water-Cooled)</li>
              <li>Expansion Valve (TXV / EXV)</li>
              <li>Receiver</li>
              <li>Oil Separator</li>
              <li>Suction Accumulator</li>
            </ul>
          </section>

          {/* 3. AIR HANDLING & DISTRIBUTION EQUIPMENT */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              3. AIR HANDLING & DISTRIBUTION EQUIPMENT
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Central AHU</li>
              <li>Modular AHU</li>
              <li>Hygienic AHU</li>
              <li>Double Skin AHU</li>
              <li>Fresh Air Handling Unit (FAHU)</li>
              <li>Heat Recovery AHU</li>
              <li>Fan Coil Unit (FCU)</li>
              <li>VAV Box</li>
              <li>CAV Box</li>
              <li>Induction Unit</li>
              <li>Centrifugal Fan</li>
              <li>Axial Fan</li>
              <li>EC Fan</li>
              <li>Plug Fan</li>
              <li>Exhaust Fan</li>
              <li>Fresh Air Fan</li>
              <li>Smoke Extraction Fan</li>
            </ul>
          </section>

          {/* 4. ROOM & ZONE-LEVEL EQUIPMENT */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              4. ROOM & ZONE-LEVEL EQUIPMENT
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Window AC</li>
              <li>Split AC</li>
              <li>Cassette AC</li>
              <li>Ducted Split AC</li>
              <li>Floor Standing AC</li>
              <li>Packaged AC</li>
              <li>Outdoor VRF Unit</li>
              <li>Indoor VRF Units (Cassette, Ducted, Wall-Mounted)</li>
              <li>Branch Selector Box</li>
              <li>Heat Recovery VRF Unit</li>
            </ul>
          </section>

          {/* 5. VENTILATION & IAQ */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              5. VENTILATION & INDOOR AIR QUALITY (IAQ)
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Mechanical Ventilation Unit</li>
              <li>Energy Recovery Ventilator (ERV)</li>
              <li>Heat Recovery Ventilator (HRV)</li>
              <li>Make-Up Air Unit (MAU)</li>
              <li>Air Purifier</li>
              <li>UVGI System</li>
              <li>Electrostatic Precipitator (ESP)</li>
              <li>Carbon Filter Unit</li>
              <li>HEPA Filter Unit</li>
            </ul>
          </section>

          {/* 6. DUCTING, PIPING & MECHANICAL ACCESSORIES */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              6. DUCTING, PIPING & MECHANICAL ACCESSORIES
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>GI Duct</li>
              <li>Pre-Insulated Duct</li>
              <li>Flexible Duct</li>
              <li>Fabric Duct</li>
              <li>Copper Pipe</li>
              <li>MS / GI Pipe</li>
              <li>PPR / HDPE Pipe</li>
              <li>Insulated Chilled Water Pipe</li>
              <li>Dampers (Volume, Fire, Smoke, Motorized)</li>
              <li>Louvers & Grilles</li>
              <li>Diffusers</li>
              <li>Vibration Isolators</li>
              <li>Flexible Connectors</li>
            </ul>
          </section>

          {/* 7. ELECTRICAL, CONTROLS & AUTOMATION */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              7. ELECTRICAL, CONTROLS & AUTOMATION
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Thermostats (Smart / Conventional)</li>
              <li>DDC Controllers</li>
              <li>PLC Panels</li>
              <li>BMS Controllers</li>
              <li>VFD / Inverter Drives</li>
              <li>Temperature Sensors</li>
              <li>Humidity Sensors</li>
              <li>Pressure Sensors</li>
              <li>Flow Sensors</li>
              <li>CO₂ Sensors</li>
              <li>VOC Sensors</li>
              <li>PM2.5 / PM10 Sensors</li>
              <li>MCC Panel</li>
              <li>Control Panel</li>
              <li>Starter Panels</li>
              <li>Power Distribution Boards</li>
            </ul>
          </section>

          {/* 8. SMART HVAC, IoT & DIGITAL EQUIPMENT */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              8. SMART HVAC, IoT & DIGITAL EQUIPMENT
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>IoT Gateways</li>
              <li>Edge Controllers</li>
              <li>Smart Meters (Energy / Water / Gas)</li>
              <li>Cloud HVAC Platforms</li>
              <li>Digital Twin Software</li>
              <li>Remote Monitoring Systems</li>
            </ul>
          </section>

          {/* 9. SAFETY, REFRIGERANT & COMPLIANCE EQUIPMENT */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              9. SAFETY, REFRIGERANT & COMPLIANCE EQUIPMENT
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Refrigerant Recovery Machine</li>
              <li>Vacuum Pump</li>
              <li>Charging Station</li>
              <li>Leak Detector (A2L Compatible)</li>
              <li>Refrigerant Cylinders</li>
              <li>Gas Detection System</li>
              <li>Emergency Ventilation System</li>
              <li>Flameproof Electrical Equipment</li>
              <li>Fire Suppression Systems</li>
            </ul>
          </section>

          {/* 10. TESTING, COMMISSIONING & MAINTENANCE TOOLS */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              10. TESTING, COMMISSIONING & MAINTENANCE TOOLS
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Manifold Gauge Set</li>
              <li>Anemometer</li>
              <li>Thermo-Hygrometer</li>
              <li>Infrared Thermometer</li>
              <li>Flow Hood</li>
              <li>Ultrasonic Leak Detector</li>
              <li>Coil Cleaning Machine</li>
              <li>Chemical Dosing System</li>
              <li>Oil Analysis Kit</li>
            </ul>
          </section>

          {/* 11. SPECIALIZED & INDUSTRIAL HVAC EQUIPMENT */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              11. SPECIALIZED & INDUSTRIAL HVAC EQUIPMENT
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>Clean Room HVAC Systems</li>
              <li>Data Center Cooling Units (CRAC / CRAH)</li>
              <li>Precision AC</li>
              <li>Industrial Process Cooling Systems</li>
              <li>District Cooling Plants</li>
            </ul>
          </section>

          {/* 12. EMERGING & FUTURE HVAC EQUIPMENT (2026+) */}
          <section className="mb-2">
            <h2 className="text-sm lg:text-lg font-semibold text-yellow-300 mb-2">
              12. EMERGING & FUTURE HVAC EQUIPMENT (2026+)
            </h2>
           <ul className="list-disc pl-6 [&>li]:text-white">
              <li>AI-Enabled Smart HVAC Systems</li>
              <li>A2L Refrigerant-Ready Equipment</li>
              <li>Hydrogen-Ready Boilers</li>
              <li>Thermal Energy Storage Systems</li>
              <li>Ice Storage Cooling Systems</li>
              <li>Solar-Assisted HVAC Systems</li>
            </ul>
          </section>
        </div>
      )}
    </div>
  );
};

export default HVACMasterlist;
